import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
// import { useForm } from "react-hook-form";
import { useFormContext, useController, Controller } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import { getConfirmationDateDisplay, isEmpty, isNotEmpty } from "../../Utils";

import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    responsible: {
        width: "16px",
        height: "16px",
    },
    color: {
        color: "#333",
    },
    border: {
        backgroundColor: "#e8e3cd",
        width: "805px",
        margin: "0 0 5px -9px",
        padding: "9px 0 9px 7px",
    },
    bottom: {
        marginBottom: "8px",
    },
    right: {
        marginRight: "0",
    },
    table: {
        minWidth: 650,
    },

    // css style for table
    locationColumn: {
        height: "50px",
        width: "200px",
        textAlign: "center",
    },

    locationBody: {
        width: "200px",
        textAlign: "center",
    },

    figureA: {
        width: "80%",
        marginLeft: "10%",
        marginRight: "10%",
    },
}));

export default function MultiColumnTable({
    headers,
    numOfColumnPerPage,
    label,
    formId,
    errors,
    records,
    // register,
    ...rest
}) {
    const [page, setPage] = useState(0);
    const { t, i18n } = useTranslation();
    // const lastPage = deduceLastPage();
    const numOfColumn = headers.length;
    const styles = useStyles();

    // const { getValues, register } = useForm();
    // const { register } = useFormContext();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const getValueDisplay = (content) => {
        return (
            <Box mb={6}>
                <Typography variant="body1" className="bold">
                    {content}
                </Typography>
            </Box>
        );
    };

    const ConditionalRender = (props) => {
        const condition = props.condition;
        const Render = props.render;

        if (condition) {
            return <Render />;
        }
        return <></>;
    };

    const tableCellHeader = (headers, formId, key) => {
        return (
            <TableRow>
                <TableCell>
                    <Typography>
                        {t(`${formId}.demMultiTable.${headers[0].name}`)}
                    </Typography>
                </TableCell>
                {headers
                    .slice(
                        1 + key * numOfColumnPerPage,
                        numOfColumnPerPage + key * numOfColumnPerPage + 1
                    )
                    .map((header) => (
                        <TableCell key={header}>
                            <Typography>
                                {t(`${formId}.demMultiTable.${header.name}`)}
                            </Typography>
                        </TableCell>
                    ))}
            </TableRow>
        );
    };

    const tableCellBody = (headers, formId, key, records, errors) => {
        console.log("tableCellBody");
        return (
            <>
                {records.map((record, index) => (
                    <TableRow key={record}>
                        <TableCell className={styles.locationBody}>
                            {getValueDisplay(
                                isEmpty(record[headers[0].name])
                                    ? t("common.na", "N/A")
                                    : record[headers[0].name]
                            )}
                        </TableCell>

                        {headers
                            .slice(
                                1 + key * numOfColumnPerPage,
                                numOfColumnPerPage +
                                    key * numOfColumnPerPage +
                                    1
                            )
                            .map((key) => (
                                <TableCell align="center" key={key}>
                                    {getValueDisplay(
                                        isEmpty(record[key.name])
                                            ? t("common.na", "N/A")
                                            : record[key.name]
                                    )}
                                </TableCell>
                            ))}
                    </TableRow>
                ))}
            </>
        );
    };

    const RenderHeaders = (props) => {
        const headers = props.headers;
        const formId = props.formId;
        let items = [];

        for (let key = 0; key < numOfColumnPerPage; key++) {
            items.push(
                <ConditionalRender
                    key={key}
                    condition={page === key}
                    render={() => tableCellHeader(headers, formId, key)}
                />
            );
        }

        return items;
    };

    const RenderBodies = (props) => {
        const headers = props.headers;
        const formId = props.formId;
        let items = [];
        console.log("RenderBodies", numOfColumnPerPage);
        for (let key = 0; key < numOfColumnPerPage; key++) {
            items.push(
                <ConditionalRender
                    key={key}
                    condition={page === key}
                    render={() =>
                        tableCellBody(headers, formId, key, records, errors)
                    }
                />
            );
        }
        console.log("renderBodies", items);

        return items;
    };

    return (
        <>
            <TableContainer>
                <Table className={styles.table} aria-label={label}>
                    <TableHead>
                        <RenderHeaders headers={headers} formId={formId} />
                    </TableHead>

                    <TableBody>
                        <RenderBodies headers={headers} formId={formId} />
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                page={page}
                rowsPerPage={1}
                count={2}
                rowsPerPageOptions={[1]}
                labelDisplayedRows={({ from, to, count, page }) => {
                    if (i18n.language === "en") {
                        return `column page ${page + 1} of ${count}`;
                    } else {
                        return `頁${page + 1}/ 頁${count}`;
                    }
                }}
                onPageChange={handleChangePage}
            />
        </>
    );
}
